import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import { minDate } from "../../Constants/Constants";

const AddTKCSOrderNumber = ({ private_order_details_id, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const [company, setCompany] = useState([]);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [productId, setProductId] = useState("");
  const [yardId, setYardID] = useState("");
  const [closingStockInYard, setClosingStockInYard] = useState("");

  const [orderNumbers, setOrderNumbers] = useState([
    { company_id: "", yard_id: "", product_name_id: "", inspection_qty: "" },
  ]);
  const [product, setProduct] = useState(Array(orderNumbers.length).fill([]));
  const [yard, setYard] = useState(Array(orderNumbers.length).fill([]));
  const [rowAddData, setRowAddData] = useState({
    di_number: "",
    di_date: "",
    last_date_di: "",
    payment_status: "",
    total_inspection_qty: "",
    di_qty: 0,
  });
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const addOrderNumberRow = () => {
    setOrderNumbers([
      ...orderNumbers,
      { company_id: "", yard_id: "", product_name_id: "", inspection_qty: "" },
    ]);
    setSelectCompanyId(""); // Reset selectCompanyId to empty string
    setProductId(""); // Reset productId to empty string
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };
  const removeOrderNumberRow = (index) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers.splice(index, 1);
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleCompanyChange = (e, index) => {
    setSelectCompanyId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].company_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
    singleYardDetails(e, index);
    getProductDetails(e, index);
  };

  function resetFields() {
    setRowAddData({
      di_number: "",
      di_date: "",
      last_date_di: "",
      payment_status: "",
      total_inspection_qty: "",
      di_qty: 0,
    });
    setProduct([]);
    setYardID("");
    setSelectCompanyId("");
    setProductId("");
    setClosingStockInYard("");
    setOrderNumbers([
      { company_id: "", yard_id: "", product_name_id: "", inspection_qty: "" },
    ]);
  }

  const getProductDetails = async (e, index) => {
    const selectedCompanyId = e.target.value;
    const BASE_URL = SERVER_URL + `/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
      }),
    });
    const result = await res.json();
    // setProduct(result.data);
    if (res.ok) {
      const updatedProducts = [...product];
      updatedProducts[index] = result.data;
      setProduct(updatedProducts);
    } else {
      setProduct([]);
    }
  };

  const handleProductChange = (e, index) => {
    setProductId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].product_name_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const singleYardDetails = async (e, index) => {
    const selectedCompanyId = orderNumbers[index].company_id;
    const BASE_URL = `${SERVER_URL}/api/com-yard/single-company-yards/${user_id}/${selectedCompanyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setYard(result.data);
      const updatedYards = [...yard];
      updatedYards[index] = result.data;
      setYard(updatedYards);
    } else {
      setYard([]);
    }
  };

  // const getSingleYardDetailClosing = async () => {
  //   const BASE_URL = `${SERVER_URL}/api/yard-details/single-yard-details/${user_id}?company_id=${selectCompanyId}&product_name_id=${productId}&yard_id=${yardId}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "GET",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   const result = await res.json();
  //   if (res.ok) {
  //     setClosingStockInYard(result.data);
  //   } else {
  //     setClosingStockInYard("");
  //   }
  // };

  // useEffect(() => {
  //   if (yardId) {
  //     getSingleYardDetailClosing();
  //   }
  // }, [yardId, productId, selectCompanyId]);

  const handleYardChange = (e, index) => {
    setYardID(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].yard_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleQtyChange = (e, index) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].inspection_qty = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleSave = (e) => {
    e.preventDefault();
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      di_number,
      di_date,
      payment_status,
      total_inspection_qty,
      di_qty,
      last_date_di,
    } = rowAddData;

    let BASE_URL =
      SERVER_URL + `/api/private-order/private-di-number/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        private_order_details_id: private_order_details_id,
        di_number,
        di_date,
        last_date_di,
        payment_status,
        // order_details: orderNumbers,
        total_inspection_qty,
        di_qty,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      setTimeout(() => {
        resetFields();
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add TKCS Order Number
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div> */}
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                      ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="di">Di Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="di_number"
                                id="di"
                                placeholder="DI Number"
                                onChange={handleChange}
                                required
                                //   onChange={(event) =>
                                //     handleChangeInput(index, event)
                                //   }
                                value={rowAddData.di_number}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="di">Total Inspection Qty</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="total_inspection_qty"
                                id="total_inspection_qty"
                                placeholder="Total Inspection Qty"
                                onChange={handleChange}
                                value={rowAddData.total_inspection_qty}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="di">Di Qty</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="di_qty"
                                id="di_qty"
                                placeholder="Di Qty"
                                onChange={handleChange}
                                value={rowAddData.di_qty}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Date">Di Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="di_date"
                                id="Date"
                                placeholder="Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={rowAddData.di_date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="last_date">Last Date Of DI</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="last_date_di"
                                id="last_date"
                                placeholder="Last Date Of DI"
                                // max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={rowAddData.last_date_di}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Status">Remark</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="payment_status"
                                id="Status"
                                placeholder="Remark"
                                onChange={handleChange}
                                value={rowAddData.payment_status}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {orderNumbers.map((order, index) => {
                        return (
                          <div key={index} className="row">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="Company">Company Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  value={order.company_id}
                                  onChange={(e) =>
                                    handleCompanyChange(e, index)
                                  }
                                  id="Company"
                                >
                                  <option value="">Select Company</option>
                                  {company.map((item, id) => (
                                    <option
                                      key={id}
                                      value={item.id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="product">Product Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  value={order.product_name_id}
                                  onChange={(e) =>
                                    handleProductChange(e, index)
                                  }
                                  disabled={!selectCompanyId}
                                  id="product"
                                >
                                  <option value="">Select Product</option>
                                  {product &&
                                    product[index]?.map((item, id) => (
                                      <option
                                        key={id}
                                        value={item.id}
                                      >{`${item.size}`}</option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="yard">Yard Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  value={order.yard_id}
                                  onChange={(e) => handleYardChange(e, index)}
                                  disabled={!selectCompanyId}
                                  id="yard"
                                >
                                  <option value="">Select yard</option>
                                  {yard &&
                                    yard[index]?.map((item, id) => (
                                      <option
                                        key={id}
                                        value={item.id}
                                      >{`${item.yard_name}`}</option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="QTY">Inspection Quantity</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={order.inspection_qty}
                                    onChange={(e) => handleQtyChange(e, index)}
                                    placeholder="Inspection Quantity"
                                    id="QTY"
                                  />
                                  <span className="input-group-append ml-2">
                                    <div className="col-md-2">
                                      {index > 0 ? (
                                        <button
                                          type="button"
                                          title="Remove"
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() =>
                                            removeOrderNumberRow(index)
                                          }
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          disabled
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                        >
                                          <i className="mdi mdi-close" />
                                        </button>
                                      )}
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })} */}
                      {/* <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span> */}
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTKCSOrderNumber;
